module.exports = __webpack_public_path__ + "img/MA Logo.27cc8ea9.svg";